import {gql} from '@apollo/client'
import {useEffect} from 'react'
import {getClient} from '../lib/api'
import {coerceString} from '../lib/helpers'
import {useAnalytics} from '../lib/analytics/analytics'
import {useBusinessUserForAnalyticsLazyQuery} from './generated/use-identify-business-user'

export const useIdentifyBusinessUser = (organisationId: string | undefined) => {
  const analytics = useAnalytics()
  // identify user
  const [getBusinessUser, {data: userData}] =
    useBusinessUserForAnalyticsLazyQuery()

  useEffect(() => {
    if (organisationId) {
      getBusinessUser({
        variables: {organisationId},
        client: getClient(organisationId)
      })
    }
  }, [organisationId, getBusinessUser])

  useEffect(() => {
    const businessUser = userData?.getOrganisationAccess?.currentBusinessUser
    if (businessUser && organisationId)
      analytics.identify({
        traits: {
          first_name: coerceString(businessUser.firstName) ?? '',
          last_name: coerceString(businessUser.lastName) ?? '',
          email: coerceString(businessUser.email) ?? '',
          org_id: organisationId,
          org_name: coerceString(businessUser.organisation?.name) ?? ''
        }
      })
  }, [analytics, userData, organisationId])
  return userData
}

// eslint-disable-next-line functional/immutable-data
useIdentifyBusinessUser.fragments = gql`
  fragment BusinessUserForAnalytics on BusinessUser {
    organisationId
    firstName
    lastName
    email
    phone
    organisation {
      name
    }
  }
`

gql`
  query BusinessUserForAnalytics($organisationId: String!) {
    getOrganisationAccess(organisationId: $organisationId) {
      currentBusinessUser {
        ...BusinessUserForAnalytics
      }
    }
  }

  ${useIdentifyBusinessUser.fragments}
`
